// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__UYMM2","header":"Messages_header__VHIN0"};